import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../index';
import { memoryNotesKeys } from './memoryNotes.keys';
import { getMemoryNotes, createMemoryNote, deleteMemoryNote, updateMemoryNote } from './memoryNotes.api';
export const useMemoryNotesQuery = () => {
    return useQuery({
        queryKey: memoryNotesKeys.all(),
        queryFn: getMemoryNotes,
        refetchInterval: 5000,
        staleTime: 0
    });
};
export const useCreateNoteMutation = () => {
    return useMutation({
        mutationFn: createMemoryNote,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memoryNotesKeys.all() }).then();
        }
    });
};
export const useUpdateNoteMutation = () => {
    return useMutation({
        mutationFn: updateMemoryNote,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memoryNotesKeys.all() }).then();
        }
    });
};
export const useDeleteNoteMutation = () => {
    return useMutation({
        mutationFn: deleteMemoryNote,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: memoryNotesKeys.all() }).then();
        }
    });
};
//# sourceMappingURL=memoryNotes.query.js.map